import { render, staticRenderFns } from "./addApplet.vue?vue&type=template&id=706145aa&scoped=true"
import script from "./addApplet.vue?vue&type=script&lang=js"
export * from "./addApplet.vue?vue&type=script&lang=js"
import style0 from "./addApplet.vue?vue&type=style&index=0&id=706145aa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706145aa",
  null
  
)

export default component.exports